<div class="support-modal">
    <!-- Header -->
    <div class="support-header">
        <h4 class="support-title">Contacto de Ayuda</h4>
        <button type="button" class="btn-close btn-close-white" (click)="activeModal.dismiss('Cross click')"
            aria-label="Close"></button>
    </div>

    <!-- Body -->
    <div class="support-body">
        <p class="support-subtitle" *ngIf="soloDemo">
            Escríbenos a WhatsApp para ayudarte
        </p>
        <p class="support-subtitle" *ngIf="!soloDemo">
            Elija su método preferido para ayudarte
        </p>

        <!-- QR Code Section -->
        <div class="qr-container">
            <div class="qr-wrapper" *ngIf="soloDemo">
                <img class="qr-image" [src]="'/assets/qr/ventas-qr-code.png'" alt="QR Code Ventas">
                <!--p class="qr-label">Escanea para ventas</p-->
            </div>
            <div class="qr-wrapper" *ngIf="!soloDemo">
                <img class="qr-image" [src]="'/assets/qr/support-qr-code.png'" alt="QR Code Soporte">
                <!--p class="qr-label">Escanea para soporte</p-->
            </div>
        </div>

        <div class="divider">
            <span>o elige una opción</span>
        </div>

        <!-- Contact Buttons -->
        <div class="contact-buttons">
            <button *ngIf="!soloDemo" type="button" class="contact-btn email-btn" (click)="email()">
                <div class="btn-icon email-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                    </svg>
                </div>
                <div class="btn-content">
                    <span class="btn-label">Correo Electrónico</span>
                    <span class="btn-detail">soporte@kuvemar.com</span>
                </div>
                <svg class="btn-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </button>

            <button *ngIf="soloDemo" type="button" class="contact-btn whatsapp-btn" (click)="whatsApp()">
                <div class="btn-icon whatsapp-icon">
                    <i class="fa-brands fa-whatsapp" style="font-size: 20px;"></i>
                </div>
                <div class="btn-content">
                    <span class="btn-label">WhatsApp</span>
                    <span class="btn-detail">+56 9 4475 8039</span>
                </div>
                <svg class="btn-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </button>

            <button *ngIf="!soloDemo" type="button" class="contact-btn whatsapp-btn" (click)="whatsAppKuvemar()">
                <div class="btn-icon whatsapp-icon">
                   <i class="fa-brands fa-whatsapp" style="font-size: 20px;"></i>
                </div>
                <div class="btn-content">
                    <span class="btn-label">WhatsApp</span>
                    <span class="btn-detail">+56 9 7981 3206</span>
                </div>
                <svg class="btn-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </button>
        </div>

        <!-- Tutorial Buttons -->
        <div class="tutorial-buttons" *ngIf="showTutorialButton">
            <button class="tutorial-btn tutorial-primary" (click)="iniciarTutorial()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                <span>Iniciar tutorial</span>
            </button>
            <button class="tutorial-btn tutorial-secondary" (click)="verTutoriales()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
                <span>Videos y módulos</span>
            </button>
        </div>
    </div>

    <!-- Footer -->
    <div class="support-footer">
        <button type="button" class="btn-close-footer" (click)="cancelar()">
            Cerrar
        </button>
    </div>
</div>